import transit from 'transit-immutable-js';
//import {Map} from 'immutable'
// import ModelList from './venture/models';

// // Initialize transit-immutable-js with our Records
// const transit = baseTransit.withRecords(ModelList);

const STORE_KEY = 'redux';

export function loadState() {
  try {
    const serializedState = localStorage.getItem(STORE_KEY);
    if (serializedState === null) {
      return undefined;
    }
    return transit.fromJSON(serializedState);
  } catch (err) {
    // If we fail to load state, just leave things undefined
    return undefined;
  }
}

export function saveState(state) {
  try {
    localStorage.setItem(STORE_KEY, transit.toJSON(state));
  } catch (err) {
    // ignore silently
  }
}



// WEBPACK FOOTER //
// ./src/local_storage.js